import * as React from 'react';
import { sortBy } from 'lodash';
import { Link } from 'react-router-dom';

import { Panel, PanelRow } from '@teamsnap/teamsnap-ui';

import Program from '../../models/program';
import ProgramCard from '../../components/program/program-card';
import ProgramEmptyList from 'components/program/program-empty-list';

export interface Props {
  orgId: number;
  programs: [Program];
  historicalSeasons: [Program];
  isLoading: boolean;
  hasError: boolean;
  isGuideOpen: boolean;
  setIsGuideOpen: (x: boolean) => void;
}

const ProgramList: React.FunctionComponent<Props> = ({ programs, historicalSeasons, isLoading,
  hasError, isGuideOpen, setIsGuideOpen, orgId }) => {
  const renderLoading = () => (
    <PanelRow mods="u-textCenter">
      <div className="Loader-indicator">
        <span className="SpinAnimation" />
        <div className="Loader-indicatorText">Loading programs...</div>
      </div>
    </PanelRow>
  );

  const renderProgram = (program: Program) => <ProgramCard key={program.id} program={program} />;

  if (isLoading) {
    return renderLoading();
  }

  return (
    <>
      <>
        {programs.length > 0 ? sortBy(programs, ['name']).map((program) => renderProgram(program as unknown as Program))
        :
        <ProgramEmptyList
          orgId={orgId}
          isGuideOpen={isGuideOpen}
          setIsGuideOpen={setIsGuideOpen}
        />
      }
      </>
      {historicalSeasons.length > 0 && (
        <Panel mods="program-card">
          <div className="u-padMd u-xs-padSidesLg u-flex u-flexAlignItemsCenter u-flexJustifyBetween">
            <div className="Grid">
              <div className="Grid-cell u-xs-size1of2">
                <div className="u-spaceBottomSm u-fontSizeXl">
                  <Link to={`/organizations/${orgId}/historical-seasons`}>Historical Seasons</Link>
                </div>
                <p className="u-colorGrey">
                  This program holds all historical seasons created on the old version of the product before upgrading.
                </p>
              </div>
            </div>
          </div>
        </Panel>
      )}
      {hasError ? <div>Unable to load your programs. Please try refreshing the page.</div> : null}
    </>
  );
};

export default ProgramList;
